<template>
    <div class="sb_page_prestaties">

        <div class="sb_structure_top">

            <div class="sb_structure_top_heading">
                <icon id="icon_prestaties" />
                <h1>sportschool prestaties
                    <span v-anime="{ opacity: [0, 1], duration: 1000}" v-if="$root.$data.vestiging">&nbsp;{{$root.$data.vestiging.naam}}</span>
                </h1>
            </div>

            <div class="sb_structure_top_logo">
                <icon id="logo_pfg" />
            </div>

        </div>

        <div class="sb_structure_content">
            <transition-group name="prestatie">
                <div v-for="(slide, n) in slides" v-if="n === currentSlideNum" :key="`slide-${n}`" class="sb_prestatie_container">

                    <div class="sb_prestatie_bg_icon">
                        <div v-anime="{ translateX: [300, 0], opacity: [0, 1], duration: 2000, delay:750}">
                            <icon :id="'icon_' + currentSlide.slug" />
                        </div>
                    </div>
                    <div class="sb_prestatie_value_container">
                        <div v-if="getCurrentData(slide.slug)" :data-score-char="getCurrentDataValue(slide.slug).toString().length" class="sb_prestatie_value">
                            <counter :duration="2000" :use-decimal-seperator="true" :round="Number(getCurrentDataValue(slide.slug)) < 100 ? 10 : 1" :number="Number(getCurrentDataValue(slide.slug))" />
                        </div>
                    </div>
                    <div class="sb_prestatie_meta_container">
                        <div v-anime="animations['fade-in-top']">
                            <div class="sb_prestatie_meta_header-text">{{ slide.headerText }}</div>
                            <div class="sb_prestatie_meta_sub-text">{{ slide.subText }}</div>
                        </div>
                        <div v-anime="animations['fade-in-bottom']" class="sb_prestatie_meta_bottom">

                            <div :class="[ isPositiveGrowth(slide.slug) ? 's_is-positive' : 's_is-negative', getGrowth(slide.slug) == 0 ? 's_is-zero' : ' ' ]" class="sb_prestatie_meta_percentage">{{ getGrowth(slide.slug) | comma }}%</div>
                            <div class="sb_prestatie_meta_divider" />
                            <div :class="{ 's_has-ribbon': getRelativeScore(slide.slug) < 4 }" class="sb_prestatie_meta_relative-score">
                                <div class="sb_prestatie_meta_relative-score_ribbon">
                                    <div class="sb_prestatie_meta_relative-score_ribbon_score">
                                        {{ getRelativeScore(slide.slug) }}
                                        <span>e</span>
                                    </div>
                                    <div class="sb_prestatie_meta_relative-score_ribbon_icon">
                                        <icon id="icon_lintje" />
                                    </div>
                                </div>
                            </div>
                            <div class="sb_prestatie_meta_relative-score_text">
                                van alle {{ branches.length }} sportscholen
                            </div>
                        </div>
                    </div>
                </div>
            </transition-group>
        </div>
        <div class="sb_structure_progress">
            <progress-bar v-for="i in slides.length" ref="progressBar" :key="'progress-bar' + i" :max-width="100" @done="progressDone(i)" />
        </div>
    </div>
</template>

<script>
import config from '@/config';
import axios from 'axios';
import ProgressBar from '@/components/ProgressBar';
import qs from 'qs';
import { getGyms } from '@/lib/backend';

export default {
    name: 'prestaties',
    components: {
        ProgressBar
    },
    filters: {
        comma(val) {
            return String(val).replace('.', ',');
        }
    },
    data() {
        return {
            branches: [],
            currentSlideNum: 0,
            setTime: 7500,
            slides: [
                {
                    headerText: 'Kilos afgevallen',
                    subText:
                        'Totaal voor deze sportschool, in de afgelopen 60 dagen',
                    slug: 'gewicht',
                    endpoint: '/statistieken/afgevallen-gewicht/dag'
                },
                {
                    headerText: 'Kilocalorieën verbrand',
                    subText:
                        'Totaal voor deze sportschool, in de afgelopen 60 dagen',
                    slug: 'calorien',
                    endpoint: '/statistieken/totaal-calorieen/dag'
                },
                {
                    headerText: 'Gemiddelde BMI',
                    subText:
                        'Gemiddelde voor deze sportschool in de afgelopen 60 dagen',
                    slug: 'bmi',
                    endpoint: '/statistieken/gemiddelde-bmi/dag'
                },
                {
                    headerText: 'Gemiddelde conditie score',
                    subText:
                        'Gemiddelde voor deze sportschool, in de afgelopen 60 dagen',
                    slug: 'conditie',
                    endpoint: '/statistieken/gemiddelde-conditie/dag'
                }
            ],
            branchData: {
                gewicht: [],
                calorien: [],
                bmi: [],
                conditie: []
            },
            vestiging: null,
            animations: {
                'fade-in-top': {
                    easing: 'easeOutQuart',
                    translateY: [-100, 0],
                    opacity: [0, 1],
                    duration: 500,
                    delay: 750
                },
                'fade-in-bottom': {
                    easing: 'easeOutQuart',
                    translateY: [100, 0],
                    opacity: [0, 1],
                    duration: 500,
                    delay: 750
                }
            }
        };
    },
    computed: {
        currentSlide() {
            return this.slides[this.currentSlideNum];
        }
    },
    async mounted() {
        const accessToken = await this.authorize();

        const branches = await this.getBranches();
        if (branches && branches.length) {
            this.branches = branches;
        }

        const promises = [];

        this.slides.forEach(slide => {
            this.branches.forEach(branch => {
                promises.push(this.getData(slide, branch, accessToken));
            });
        });

        await Promise.all(promises);

        for (let key in this.branchData) {
            this.branchData[key].sort(
                (a, b) => b.data.huidige.waarde - a.data.huidige.waarde
            );
        }

        if (this.$route.query.vestiging) {
            this.vestiging = this.branches.find(
                branch => branch.id === +this.$route.query.vestiging
            );
        }

        this.$nextTick(() => {
            this.$refs.progressBar[this.currentSlideNum].start(this.setTime);
        });
    },
    methods: {
        async authorize() {
            const { data, status } = await axios({
                method: 'POST',
                url: `${config.CLUB_API}/oauth2/access_token`,
                data: qs.stringify({
                    grant_type: 'client_credentials',
                    client_id: config.CLUB_CLIENT,
                    client_secret: config.CLUB_SECRET
                }),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            if (!data || !data.access_token) throw new Error('no access_token');
            if (status !== 200) throw new Error('no 200 response');
            return data.access_token;
        },
        async getBranches() {
            const gyms = await getGyms();
            return gyms.map(gym => ({
                ...gym,
                naam: gym.name,
                mappingNaam: gym.slug
            }));
        },
        progressDone() {
            if (this.currentSlideNum < this.slides.length - 1) {
                this.currentSlideNum++;
            } else {
                this.currentSlideNum = 0;
                this.$refs.progressBar.forEach(progressBar =>
                    progressBar.reset()
                );
                this.$root.$emit('cycle-finished', 'prestaties');
            }
            this.$refs.progressBar[this.currentSlideNum].start(this.setTime);
        },
        async getData(obj, branch, accessToken) {
            var d = new Date();
            d.setDate(d.getDate() - 7);

            const day = d.getDate();
            const month = d.getMonth() + 1;
            const year = d.getFullYear();
            const res = await axios.get(
                `${config.CLUB_API}${
                    obj.endpoint
                }?vergelijkMet=vorige-periode&datum=${day}-${month}-${year}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        'Gym-Location': branch.mappingNaam
                    }
                }
            );
            this.branchData[obj.slug].push(res);
        },
        getRelativeScore(slug) {
            if (!this.vestiging) return '';

            const reverseBranchDataImmutable = (branchData, current) => [
                current,
                ...branchData
            ];
            const findVestigingIndex = current =>
                current.data.huidige.vestiging === this.vestiging.id;

            if (slug === 'bmi') {
                return (
                    this.branchData['bmi']
                        .reduce(reverseBranchDataImmutable, [])
                    .findIndex(findVestigingIndex) + 1
                );
            }

            return this.branchData[slug].findIndex(findVestigingIndex) + 1;
        },
        getCurrentData(slug) {
            if (!this.vestiging) return '';
            const data = this.branchData[slug].filter(
                branch => branch.data.huidige.vestiging === this.vestiging.id
            )[0];
            if (data) {
                return data;
            }
            return {};
        },
        getCurrentDataValue(slug) {
            const data = this.getCurrentData(slug);
            const value = Number(data.data.huidige.waarde);
            if (value < 100) {
                return value.toFixed(1);
            }

            if (slug === 'calorien') {
              return value / 1000;
            }

            return value;
        },
        getGrowth(slug) {
            if (!this.vestiging) return '';
            const data = this.getCurrentData(slug);
            const newValue = data.data.huidige.waarde;
            const oldValue = data.data.vorige.waarde;
            if (data) {
                if (newValue === 0 || oldValue === 0) return 0;
                return Number(
                    (((newValue - oldValue) / oldValue) * 100).toFixed(1)
                );
            }
            return '';
        },
        isPositiveGrowth(slug) {
            const growth = this.getGrowth(slug);
            if (slug === 'bmi') {
                return growth <= 0;
            }
            return growth >= 0;
        }
    }
};
</script>


<style lang="scss">
//
//      ANIMATIONS
//

.prestatie-enter-active,
.prestatie-leave-active {
    transition: all 0.4s ease-out;
}
.prestatie-enter,
.prestatie-leave-to {
    opacity: 0;
    transform: translateY(30px);
}
.prestatie-enter-active {
    transition-delay: 0.8s;
}
.prestatie-leave-active {
}

//
//      PAGE
//

.sb_page_prestaties {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    background: url('~@/assets/bg-color-3.jpg');
    background-size: cover;
    background-position: 50% 50%;
    .sb_structure_content {
        position: relative;
        overflow: hidden;
    }
}

//
//      MAIN
//

.sb_prestatie_container {
    position: fixed;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    font-size: 3rem;
}

//
//      BG - ICON
//

.sb_prestatie_bg_icon {
    position: fixed;
    top: 50%;
    right: 0;
    transform: translateY(-50%) translateX(30%);

    svg {
        width: 110rem;
        height: 110rem;
        fill: rgba($brand-white, 0.04);
    }
}

//
//      VALUE
//

.sb_prestatie_value_container {
    width: 50%;
    max-width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.sb_prestatie_value {
    font-size: 40rem;
    letter-spacing: -20px;
    text-align: center;
    @include font-body-thin;
    transform: translateY(10%);

    &[data-score-char='4'] {
        font-size: 36rem;
        letter-spacing: -16px;
    }
    &[data-score-char='5'] {
        font-size: 30rem;
        letter-spacing: -13px;
    }
    &[data-score-char='6'] {
        font-size: 23rem;
        letter-spacing: -10px;
    }
    &[data-score-char='7'] {
        font-size: 21rem;
        letter-spacing: -10px;
    }
    &[data-score-char='8'] {
        font-size: 19rem;
        letter-spacing: -10px;
    }
    &[data-score-char='9'] {
        font-size: 17rem;
        letter-spacing: -10px;
    }
    &[data-score-char='10'] {
        font-size: 15rem;
        letter-spacing: -10px;
    }
    &[data-score-char='11'] {
        font-size: 14rem;
        letter-spacing: -10px;
    }
}

//
//      META
//

.sb_prestatie_meta_container {
    width: 50%;
    max-width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.sb_prestatie_meta_header-text {
    @include font-body-light;
    font-size: 6rem;
}
.sb_prestatie_meta_sub-text {
    @include font-body-light;
    opacity: 0.7;
    margin: 2rem 0;
}
.sb_prestatie_meta_bottom {
    display: flex;
    align-items: center;
    margin-top: 5rem;
}
.sb_prestatie_meta_percentage {
    min-width: 14rem;
    text-align: center;
    background: $brand-error;
    padding: 1.6rem 2rem 1rem 2rem;
    border-radius: 0.5rem;

    &.s_is-positive {
        background: $brand-success;
    }
    &.s_is-zero {
        background: $brand-primary;
    }
}
.sb_prestatie_meta_divider {
    width: 2px;
    height: 100px;
    background: rgba($brand-white, 0.7);
    margin: 0 4rem;
}

//
//      META - RELATIVE SCORE
//

.sb_prestatie_meta_relative-score {
    @include font-body-light;

    &.s_has-ribbon {
        .sb_prestatie_meta_relative-score_ribbon_icon {
            display: block;
        }
    }
}
.sb_prestatie_meta_relative-score_ribbon {
    position: relative;
    display: flex;
    align-items: center;
    margin-right: 2rem;
    transform: translateY(1rem);
}
.sb_prestatie_meta_relative-score_ribbon_score {
    font-size: 6rem;
    display: flex;
    justify-content: center;
    width: 10rem;
    span {
        margin-left: 0.2rem;
        display: inline-block;
        font-size: 2rem;
    }
}
.sb_prestatie_meta_relative-score_ribbon_icon {
    display: none;
    position: absolute;
    left: 0;
    top: 0;
    transform: translateX(-24%) translateY(-22%);
    svg {
        width: 18rem;
        height: 18rem;
        fill: $brand-white;
    }
}
.sb_prestatie_meta_relative-score_text {
    font-size: 2rem;
    opacity: 0.7;
}
</style>
